var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_40360)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22656 0.0742188H24.7734C26.6884 0.0797155 28.5233 0.842849 29.8773 2.1969C31.2314 3.55096 31.9945 5.38587 32 7.30078V24.7018C31.9938 26.6163 31.2304 28.4505 29.8764 29.804C28.5224 31.1575 26.6879 31.9203 24.7734 31.9258H7.22656C5.3121 31.9203 3.47758 31.1575 2.1236 29.804C0.769619 28.4505 0.00618337 26.6163 0 24.7018V7.30078C0.00549674 5.38587 0.76863 3.55096 2.12268 2.1969C3.47674 0.842849 5.31165 0.0797155 7.22656 0.0742188Z",
    fill: "#0A66C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8099 12.4206H16.8542V14.5039H16.9115C17.4766 13.4935 18.8516 12.4206 20.9063 12.4206C25.1745 12.4206 25.9635 15.0768 25.9635 18.5325V25.8398H21.7474V19.3451C21.7474 17.8581 21.7161 15.944 19.5547 15.944C17.3932 15.944 17.0234 17.5612 17.0234 19.2383V25.8529H12.8099V12.4206ZM10.4167 8.35286C10.4167 8.78654 10.2881 9.21048 10.0471 9.57107C9.80619 9.93166 9.46374 10.2127 9.06307 10.3787C8.66241 10.5446 8.22153 10.588 7.79618 10.5034C7.37084 10.4188 6.98014 10.21 6.67348 9.90334C6.36682 9.59669 6.15799 9.20598 6.07338 8.78064C5.98878 8.3553 6.0322 7.91442 6.19816 7.51375C6.36412 7.11309 6.64517 6.77063 7.00576 6.52969C7.36634 6.28876 7.79028 6.16016 8.22396 6.16016C8.80529 6.16085 9.36261 6.39208 9.77368 6.80315C10.1847 7.21421 10.416 7.77153 10.4167 8.35286ZM6.03646 12.4206H10.4167V25.8398H6.03646V12.4206Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_40360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.8516,
    fill: "white",
    transform: "translate(0 0.0742188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin1);
export default __webpack_public_path__ + "static/media/linkedin1.9564f58d0d78717c7785da8549668474.svg";
export { ForwardRef as ReactComponent };